var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1856_1726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.5869 69.5869H0V0H69.5869V69.5869ZM2.82147 66.7654H66.7654V2.82147H2.82147V66.7654Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5403 54.0738H25.4453V15.5137H37.2155V42.3035H43.5403C46.785 42.3035 49.4231 44.9416 49.4231 48.1863C49.4231 51.431 46.785 54.0691 43.5403 54.0691V54.0738ZM28.2668 51.2523H43.5403C45.2285 51.2523 46.6016 49.8792 46.6016 48.191C46.6016 46.5028 45.2285 45.1297 43.5403 45.1297H34.3941V18.3398H28.2668V51.2523Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1502 41.2313C24.943 41.2313 19.8926 36.1808 19.8926 29.9736C19.8926 29.193 20.5227 28.5629 21.3033 28.5629C22.0839 28.5629 22.714 29.193 22.714 29.9736C22.714 34.6243 26.4995 38.4098 31.1502 38.4098C35.801 38.4098 39.5864 34.6243 39.5864 29.9736C39.5864 27.0158 38.0064 24.2319 35.4577 22.7177C34.7899 22.318 34.5689 21.4528 34.9686 20.785C35.3683 20.1173 36.2336 19.8963 36.9013 20.296C40.3012 22.318 42.4079 26.0282 42.4079 29.9783C42.4079 36.1855 37.3575 41.236 31.1502 41.236V41.2313Z",
    fill: "#26E71E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.216 16.9238H34.3945V31.4591H37.216V16.9238Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2668 29.541H25.4453V43.7095H28.2668V29.541Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1856_1726"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69.5869,
    height: 69.5869,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLogoLight);
export default __webpack_public_path__ + "static/media/newLogoLight.036be96879cd70a9c2022d4ba8866c9e.svg";
export { ForwardRef as ReactComponent };